
Vue.component('bar', require('./components/Bar').default);
Vue.component('dsi-code', require('./components/DSICode').default);
Vue.component('dsi-chart', require('./components/DSIChart').default);
Vue.component('dsi-folder', require('./components/DSIFolder').default);

Vue.component('database', require('./components/Database').default);
Vue.component('feedback', require('./components/Feedback').default);
Vue.component('autocomplete', require('./components/search/autocomplete').default);
Vue.component('buckets', require('./components/search/Buckets').default);
Vue.component('search-series', require('./components/search/SearchSeries').default);

Vue.component('graphic', require('./components/sheets/Graphic').default);
Vue.component('gra', require('./components/sheets/Gra').default);

Vue.component('input-pattern', require('./components/patterns/InputPattern').default);
Vue.component('pattern-chart', require('./components/patterns/PatternChart').default);
Vue.component('single-chart', require('./components/SingleChart').default);
Vue.component('select-series', require('./components/patterns/SelectSeries').default);
Vue.component('create-pattern', require('./components/patterns/CreatePattern').default);
Vue.component('data-chart', require('./components/patterns/DataChart').default);
Vue.component('pattern-type', require('./components/patterns/PatternType').default);

Vue.component('step', require('./components/Step').default);
Vue.component('stepper', require('./components/Stepper').default);
Vue.component('stepy', require('./components/Stepy').default);

Vue.component('database-storage', require('./components/database/Storage').default);
Vue.component('database-database', require('./components/database/Database').default);

Vue.component('checklist', require('./components/Checklist').default);
Vue.component('new-selection', require('./components/NewSelection').default);

// TODO extra.js ;-)
Vue.component('cross-country', require('./projects/CrossCountry').default);
Vue.component('best-countries', require('./projects/BestCountries').default);
Vue.component('country-compare', require('./projects/CountryCompare').default);

new Vue({

    el: '#vue',

    provide() {
        return {
            report: this.report,
        };
    },

    data() {
        return {
            report: {
                selected: [],
                id: null,
            },
        };
    },

    mounted() {
        this.getStorage();
    },

    watch: {
        'report.selected': function () {
            this.updateState();
        }
    },

    methods: {
        updateState() {
            sessionStorage.setItem('report', JSON.stringify({
                series: this.report.selected,
            }));
        },
        getStorage() {
            let items = JSON.parse(sessionStorage.getItem('report'));

            if (items === null) {
                items = {};
            }

            if (!items.series || !Array.isArray(items.series)) {
                items.series = [];
            }

            this.report.selected = items.series;
        },
    },

});
